import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from "vue-router";
import { NextLoading } from "@/utils/loading/loading";
import NProgress from "nprogress";
import store from "@/store";
import _ from "lodash";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    meta: { isAuth: false },
    component: () => import(/* webpackChunkName: "login" */ "@/layout/login.vue"),
  },
  {
    path: "/main",
    name: "main",
    meta: { isAuth: false },
    redirect: "/home",
    component: () => import(/* webpackChunkName: "main" */ "@/layout/main.vue"),
    children: [
      { path: "/pageAuth", meta: { isAuth: false, perm: "" }, component: () => import(/* webpackChunkName: "pageAuth" */ "@/layout/noAuth.vue") },
      { path: "/home", meta: { isAuth: false, perm: "" }, component: () => import(/* webpackChunkName: "home" */ "@/layout/home.vue") },
      {
        path: "/staging",
        meta: { isAuth: true, perm: "staging" },
        component: () => import(/* webpackChunkName: "staging" */ "@/layout/staging.vue"),
      },
      {
        path: "/user",
        meta: { isAuth: true, perm: "organize.user.query" },
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/user/userList.vue"),
      },
      {
        path: "/menu",
        meta: { isAuth: true, perm: "organize.menu.query" },
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/menu/menuList.vue"),
      },
      {
        path: "/role",
        meta: { isAuth: true, perm: "organize.role.query" },
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/role/roleList.vue"),
      },
      {
        path: "/auth",
        meta: { isAuth: true, perm: "organize.auth.query" },
        component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/auth/auth.vue"),
      },
      {
        path: "/notice",
        meta: { isAuth: true, perm: "system.notice.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/notice/notice.vue"),
      },
      {
        path: "/config",
        meta: { isAuth: true, perm: "system.config.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/mallConfig/config.vue"),
      },
      {
        path: "/source",
        meta: { isAuth: true, perm: "system.source.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/source/source.vue"),
      },
      {
        path: "/agree",
        meta: { isAuth: true, perm: "system.agree.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/agreement/agreement.vue"),
      },
      {
        path: "/cert",
        meta: { isAuth: true, perm: "system.cert.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/cert/certList.vue"),
      },
      {
        path: "/activity",
        meta: { isAuth: true, perm: "system.activity.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/activity/activity.vue"),
      },
      {
        path: "/complaint",
        meta: { isAuth: true, perm: "system.complaint.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/complaint/index.vue"),
      },
      {
        path: "/plaza",
        meta: { isAuth: true, perm: "plaza.plaza.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/plaza/plazaList.vue"),
      },
      {
        path: "/page",
        meta: { isAuth: true, perm: "system.page.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/apppage/pageList.vue"),
      },
      {
        path: "/chat",
        meta: { isAuth: true, perm: "system.chat.query" },
        component: () => import(/* webpackChunkName: "system" */ "@/views/system/chat/chatList.vue"),
      },
      {
        path: "/career",
        meta: { isAuth: true, perm: "job.career.query" },
        component: () => import(/* webpackChunkName: "job" */ "@/views/job/career/careerList.vue"),
      },
      {
        path: "/careerDesc",
        meta: { isAuth: true, perm: "job.careerDesc.query" },
        component: () => import(/* webpackChunkName: "job" */ "@/views/job/careerDesc/descList.vue"),
      },
      {
        path: "/work",
        meta: { isAuth: true, perm: "job.work.query" },
        component: () => import(/* webpackChunkName: "job" */ "@/views/job/work/workList.vue"),
      },
      {
        path: "/jobPrefer",
        meta: { isAuth: true, perm: "job.jobPrefer.query" },
        component: () => import(/* webpackChunkName: "job" */ "@/views/job/jobPrefer/jobPreferList.vue"),
      },
      {
        path: "/member",
        meta: { isAuth: true, perm: "ms.member.query" },
        component: () => import(/* webpackChunkName: "member" */ "@/views/memService/member/memberList.vue"),
      },
      {
        path: "/drone",
        meta: { isAuth: true, perm: "ms.drone.query" },
        component: () => import(/* webpackChunkName: "member" */ "@/views/memService/drone/droneList.vue"),
      },
      {
        path: "/guaranteeOrder",
        meta: { isAuth: true, perm: "ms.guaranteeOrder.query" },
        component: () => import(/* webpackChunkName: "member" */ "@/views/memService/guarantee/order/guaranteeOrderList.vue"),
      },
      {
        path: "/memGuarantee",
        meta: { isAuth: true, perm: "ms.memGuarantee.query" },
        component: () => import(/* webpackChunkName: "member" */ "@/views/memService/guarantee/member/memberGuaranteeList.vue"),
      },
      {
        path: "/location",
        meta: { isAuth: true, perm: "ms.locate.query" },
        component: () => import(/* webpackChunkName: "member" */ "@/views/memService/location/location.vue"),
      },
      {
        path: "/msrank",
        meta: { isAuth: true, perm: "ms.rank.query" },
        component: () => import(/* webpackChunkName: "member" */ "@/views/memService/rank/rankList.vue"),
      },
      {
        path: "/memverify",
        meta: { isAuth: true, perm: "ms.verify.query" },
        component: () => import(/* webpackChunkName: "member" */ "@/views/memService/verify/verify.vue"),
      },
      {
        path: "/recharge",
        meta: { isAuth: true, perm: "ms.recharge.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/memService/recharge/rechargeRecordList.vue"),
      },
      {
        path: "/bill",
        meta: { isAuth: true, perm: "cw.bill.query" },
        component: () => import(/* webpackChunkName: "finance" */ "@/views/finance/bill/billList.vue"),
      },
      {
        path: "/billapply",
        meta: { isAuth: true, perm: "cw.bapply.query" },
        component: () => import(/* webpackChunkName: "finance" */ "@/views/finance/billapply/billApplyList.vue"),
      },
      {
        path: "/billPay",
        meta: { isAuth: true, perm: "cw.bpay.query" },
        component: () => import(/* webpackChunkName: "finance" */ "@/views/finance/billPay/billPayList.vue"),
      },
      {
        path: "/mbwith",
        meta: { isAuth: true, perm: "cw.mbwith.query" },
        component: () => import(/* webpackChunkName: "finance" */ "@/views/finance/mbwith/mbwithList.vue"),
      },
      {
        path: "/product",
        meta: { isAuth: true, perm: "product.list.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/product/productList.vue"),
      },
      {
        path: "/productAdd",
        meta: { isAuth: false, perm: "product.list.add" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/product/productAdd.vue"),
      },
      {
        path: "/productEdit",
        meta: { isAuth: false, perm: "product.list.edit" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/product/productEdit.vue"),
      },
      {
        path: "/productInfo",
        meta: { isAuth: false, perm: "product.list.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/product/productInfo.vue"),
      },
      {
        path: "/cate",
        meta: { isAuth: true, perm: "product.cate.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/cate/cate.vue"),
      },
      {
        path: "/specs",
        meta: { isAuth: true, perm: "product.specs.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/product/specs/specs.vue"),
      },
      {
        path: "/order",
        meta: { isAuth: true, perm: "order.list.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/order/order/orderList.vue"),
      },
      {
        path: "/chatDirect",
        meta: { isAuth: true, perm: "chat.direct.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/finance/chatDirect/chatDirect.vue"),
      },
      {
        path: "/vipConfig",
        meta: { isAuth: true, perm: "vip.config.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/vip/vipConfig/index.vue"),
      },
      {
        path: "/vipApply",
        meta: { isAuth: true, perm: "vip.apply.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/vip/vipApply/index.vue"),
      },
      {
        path: "/vipRecord",
        meta: { isAuth: true, perm: "vip.record.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/vip/vipRecord/index.vue"),
      },
      {
        path: "/investigate",
        meta: { isAuth: true, perm: "system.investigate.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/system/investigate/index.vue"),
      },
      {
        path: "/version",
        meta: { isAuth: true, perm: "system.version.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/system/version/index.vue"),
      },
      {
        path: "/task",
        meta: { isAuth: true, perm: "system.task.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/system/task/task.vue"),
      },
       {
        path: "/jobPlate",
        meta: { isAuth: true, perm: "job.template.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/job/template/template.vue"),
      },
      {
        path: "/enterprise",
        meta: { isAuth: true, perm: "ep.enterprise.query" },
        component: () => import(/* webpackChunkName: "product" */ "@/views/enterprise/enterpriseList.vue"),
      },
    ],
  },
  {
    path: "/noAuth",
    name: "noAuth",
    meta: { isAuth: false },
    component: () => import("@/layout/noAuth.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: { isAuth: false },
    component: () => import("@/layout/404.vue"),
  },
  // 所有未定义路由，全部重定向到404页，必须放在最后
  {
    path: "/:pathMatch(.*)",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_WEB),
  routes,
});
router.beforeEach((to, from, next) => {
  let path = to.path;
  let isAuth = to.meta.isAuth;
  let perm: any = to.meta.perm;
  if (window.nextLoading === undefined) NextLoading.start();
  NProgress.start();
  if (isAuth) {
    let menu = JSON.stringify(store.state.adminInfo.menuChildren).indexOf(path) != -1 ? true : false;
    if (menu) {
      let auth = perm && JSON.stringify(store.state.adminInfo.menuAuthChildren).indexOf(perm) != -1 ? true : false;
      if (auth) next();
      else next("/pageAuth");
    } else next("/noAuth");
  } else {
    next();
  }
});
router.afterEach(() => {
  NProgress.done();
  NextLoading.done();
});
export default router;
